export const MAX_DOCUMENT_VIEWER_FILE_SIZE_MB = 300;

export const DOCUMENT_VIEWER_FILE_SIZE_TOO_LARGE_MESSAGE =
  'Preview unavailable, file size too large.  We are working on improving this.';

export function isDocumentViewerFileSizeTooLarge(sizeMb?: number | null): boolean {
  return typeof sizeMb === 'number' && Number.isFinite(sizeMb) && sizeMb > MAX_DOCUMENT_VIEWER_FILE_SIZE_MB;
}

/** Zoom steps shared by the PDF and image previews. */
export const PREVIEW_ZOOM_STEP = 0.25;
export const PREVIEW_MIN_ZOOM = 0.5;
export const PREVIEW_MAX_ZOOM = 3;
